import { render, staticRenderFns } from "./InvoiceBulkClaimDeleteConfirmationDialog.vue?vue&type=template&id=a37d7852&lang=pug&"
import script from "./InvoiceBulkClaimDeleteConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./InvoiceBulkClaimDeleteConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports